
import React from 'react';
import { Phone } from 'lucide-react';

export const DialerHeader = () => {
  return (
    <div className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 px-4 py-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Phone className="h-5 w-5 text-muted-foreground" />
          <p className="text-muted-foreground">Make and manage voice calls</p>
        </div>
      </div>
    </div>
  );
};
